var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCnvs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4976_8418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.875 24.125H18M24 24.125H28M36.5 24.125H40M46.5 24.125H50M63 24.125H65.125",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.875 56.1249H18M24 56.1249H26M44 56.1249L46 56.1249M62 56.125H65.125",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 56.0001H56",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 56H35.9999",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 53C26 52.4477 26.4477 52 27 52H30.6674C30.993 52 31.2981 52.1584 31.4854 52.4247L33.5954 55.4247C33.8381 55.7698 33.8381 56.2302 33.5954 56.5753L31.4854 59.5753C31.2981 59.8416 30.993 60 30.6674 60H27C26.4477 60 26 59.5523 26 59V53Z",
    stroke: "#161616",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 21.0001C28 20.4478 28.4477 20.0001 29 20.0001H32.6674C32.993 20.0001 33.2981 20.1585 33.4854 20.4248L35.5954 23.4248C35.8381 23.7699 35.8381 24.2302 35.5954 24.5753L33.4854 27.5753C33.2981 27.8416 32.993 28.0001 32.6674 28.0001H29C28.4477 28.0001 28 27.5523 28 27.0001V21.0001Z",
    stroke: "#161616",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 53.0001C36 52.4478 36.4477 52.0001 37 52.0001H40.6674C40.993 52.0001 41.2981 52.1585 41.4854 52.4248L43.5953 55.4248C43.8381 55.7699 43.8381 56.2302 43.5953 56.5753L41.4854 59.5753C41.2981 59.8416 40.993 60.0001 40.6674 60.0001H37C36.4477 60.0001 36 59.5523 36 59.0001V53.0001Z",
    stroke: "#161616",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 21.0001C50 20.4478 50.4477 20.0001 51 20.0001H59.5666C59.8856 20.0001 60.1854 20.1522 60.3738 20.4097L62.5681 23.4097C62.8253 23.7613 62.8253 24.2389 62.5681 24.5904L60.3738 27.5904C60.1854 27.8479 59.8856 28.0001 59.5666 28.0001H51C50.4477 28.0001 50 27.5523 50 27.0001V21.0001Z",
    stroke: "#161616",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9999 53C45.9999 52.4477 46.4477 52 46.9999 52H50.6674C50.9929 52 51.2981 52.1584 51.4854 52.4247L53.5953 55.4247C53.8381 55.7698 53.8381 56.2302 53.5953 56.5753L51.4854 59.5753C51.2981 59.8416 50.9929 60 50.6674 60H46.9999C46.4477 60 45.9999 59.5523 45.9999 59V53Z",
    stroke: "#161616",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 53C18 52.4477 18.4477 52 19 52L20.6674 52C20.993 52 21.2981 52.1585 21.4854 52.4247L23.5953 55.4247C23.8381 55.7698 23.8381 56.2302 23.5953 56.5753L21.4854 59.5753C21.2981 59.8416 20.993 60 20.6674 60L19 60C18.4477 60 18 59.5523 18 59V53Z",
    stroke: "#161616",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 21C17.9999 20.4477 18.4477 20 18.9999 20L20.6674 20C20.9929 20 21.2981 20.1585 21.4854 20.4247L23.5953 23.4247C23.8381 23.7698 23.8381 24.2302 23.5953 24.5753L21.4854 27.5753C21.2981 27.8416 20.9929 28 20.6674 28L18.9999 28C18.4477 28 17.9999 27.5523 17.9999 27V21Z",
    stroke: "#161616",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 53C62 52.4477 61.5523 52 61 52L59.3325 52C59.007 52 58.7018 52.1585 58.5146 52.4247L56.4046 55.4247C56.1619 55.7698 56.1619 56.2302 56.4046 56.5753L58.5146 59.5753C58.7018 59.8416 59.007 60 59.3325 60L61 60C61.5523 60 62 59.5523 62 59V53Z",
    stroke: "#161616",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 21C46 20.4477 45.5523 20 45 20L43.3325 20C43.007 20 42.7018 20.1585 42.5146 20.4247L40.4046 23.4247C40.1619 23.7698 40.1619 24.2302 40.4046 24.5753L42.5146 27.5753C42.7018 27.8416 43.007 28 43.3325 28L45 28C45.5523 28 46 27.5523 46 27V21Z",
    stroke: "#161616",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3784 47.5L29.3785 38.0001H49.5V47.5",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9972 47.6188C32.3389 47.2771 32.3389 46.7231 31.9972 46.3813C31.6555 46.0396 31.1014 46.0396 30.7597 46.3813L31.9972 47.6188ZM29.3784 49.0001L28.7597 49.6188C29.1014 49.9605 29.6555 49.9605 29.9972 49.6188L29.3784 49.0001ZM27.9972 46.3813C27.6555 46.0396 27.1014 46.0396 26.7597 46.3813C26.418 46.7231 26.418 47.2771 26.7597 47.6188L27.9972 46.3813ZM30.7597 46.3813L28.7597 48.3813L29.9972 49.6188L31.9972 47.6188L30.7597 46.3813ZM29.9972 48.3813L27.9972 46.3813L26.7597 47.6188L28.7597 49.6188L29.9972 48.3813Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8247 47.6187C46.483 47.277 46.483 46.723 46.8247 46.3813C47.1664 46.0396 47.7204 46.0396 48.0621 46.3813L46.8247 47.6187ZM49.4434 49L50.0621 49.6187C49.7204 49.9604 49.1664 49.9604 48.8247 49.6187L49.4434 49ZM50.8247 46.3813C51.1664 46.0396 51.7204 46.0396 52.0621 46.3813C52.4038 46.723 52.4038 47.277 52.0621 47.6187L50.8247 46.3813ZM48.0621 46.3813L50.0621 48.3813L48.8247 49.6187L46.8247 47.6187L48.0621 46.3813ZM48.8247 48.3813L50.8247 46.3813L52.0621 47.6187L50.0621 49.6187L48.8247 48.3813Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8965 47.6187C36.5547 47.277 36.5547 46.723 36.8965 46.3813C37.2382 46.0396 37.7922 46.0396 38.1339 46.3813L36.8965 47.6187ZM39.5152 49L40.1339 49.6187C39.7922 49.9604 39.2382 49.9604 38.8965 49.6187L39.5152 49ZM40.8965 46.3813C41.2382 46.0396 41.7922 46.0396 42.1339 46.3813C42.4756 46.723 42.4756 47.277 42.1339 47.6187L40.8965 46.3813ZM38.1339 46.3813L40.1339 48.3813L38.8965 49.6187L36.8965 47.6187L38.1339 46.3813ZM38.8965 48.3813L40.8965 46.3813L42.1339 47.6187L40.1339 49.6187L38.8965 48.3813Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 38V48",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 31V37",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4976_8418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnvs);
export default __webpack_public_path__ + "static/media/cnvs.87ced1b85e63db101baec3d95312c153.svg";
export { ForwardRef as ReactComponent };